
export function extractSurveyYear(cameraSlug: string): string {
  const parts = cameraSlug.split('-');
  return parts.length >= 2
    ? `${parts[parts.length - 2]}-${parts[parts.length - 1]}`
    : '';
}
